import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showDialog: false,
  data: null,
};

const priceChangeSlice = createSlice({
  name: 'priceChange',
  initialState,
  reducers: {
    showPriceChangeDialog: (state, action) => {
      state.showDialog = true;
      state.data = action.payload;
    },
    hidePriceChangeDialog: (state) => {
      state.showDialog = false;
      state.data = null;
    },
  },
});

export const { showPriceChangeDialog, hidePriceChangeDialog } = priceChangeSlice.actions;
export default priceChangeSlice.reducer;
